import { render, staticRenderFns } from "./AddSelfPickupGoodsRider.vue?vue&type=template&id=1a87256f&scoped=true"
import script from "./AddSelfPickupGoodsRider.vue?vue&type=script&lang=js"
export * from "./AddSelfPickupGoodsRider.vue?vue&type=script&lang=js"
import style0 from "./AddSelfPickupGoodsRider.vue?vue&type=style&index=0&id=1a87256f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a87256f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a87256f')) {
      api.createRecord('1a87256f', component.options)
    } else {
      api.reload('1a87256f', component.options)
    }
    module.hot.accept("./AddSelfPickupGoodsRider.vue?vue&type=template&id=1a87256f&scoped=true", function () {
      api.rerender('1a87256f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryInfo/AddSelfPickupGoodsRider.vue"
export default component.exports